
import type { RankingElement } from '@empathybroker/tsclient-play/dist/models/ranking-element'
import type { PropType } from 'vue'
import type { RegularFilterConfig } from '../../models/store/filters/filter-config'

import { defineComponent } from 'vue'
import RankingElementAside from './ranking-element-aside.component.vue'

export default defineComponent({
  name: 'AttributeRankingElementAside',
  components: {
    RankingElementAside,
  },
  props: {
    element: {
      type: Object as PropType<RankingElement>,
      required: true,
    },
    filterConfigs: {
      type: Array as PropType<Array<RegularFilterConfig>>,
      required: true,
    },
    messages: {
      type: Object,
      required: true,
    },
  },
})
